import styled from "styled-components"

import { minWidth } from "utils"

export const TopAdContainer = styled.div`
  height: 5rem;
  visibility: hidden;
  background-color: ${({ background }) => background};

  ${minWidth.tablet`
    display: none;
  `}
`
